import React from 'react';

const withLocalizeAwareIframe = BaseComponent =>
  class WithLocalizeAwareIframe extends React.Component {
    constructor(props) {
      super(props);
      this.setRef = this.setRef.bind(this);
      this.onLanguageChange = this.onLanguageChange.bind(this);
      this.setLanguage = this.setLanguage.bind(this);
    }

    componentDidMount() {
      this.iframeEl = this.el.getElementsByTagName('iframe')[0];
      this.iframeEl.addEventListener('load', this.handleLanguage);
    }

    componentWillUnmount() {
      if (window.Localize) {
        window.Localize.off('setLanguage', this.onLanguageChange);
      }
      this.iframeEl.removeEventListener('load', this.handleLanguage);
    }

    onLanguageChange(options) {
      this.setLanguage(options.to);
    }

    setRef(el) {
      this.el = el;
    }

    setLanguage(language) {
      const message = {
        type: 'setLanguage',
        payload: { language },
      };
      this.iframeEl.contentWindow.postMessage(message, '*');
    }

    handleLanguage = () => {
      if (window.Localize) {
        this.setLanguage(window.Localize.getLanguage());
        window.Localize.on('setLanguage', this.onLanguageChange);
      }
    };

    render() {
      return (
        <div ref={this.setRef} style={{ width: '100%', height: '100%' }}>
          <BaseComponent {...this.props} />
        </div>
      );
    }
  };

export default withLocalizeAwareIframe;
